import React from 'react';
import './Toggle.css';

// On/off switch (role="switch"). `label` is the text beside it; pass a
// different label per state at the call site when the wording should change.
// `stretch` makes the track fill the height of its flex row (e.g. to sit level
// with neighbouring buttons) instead of the fixed 20px.
export const Toggle = ({ checked, onChange, label, disabled = false, stretch = false, className = '', ...rest }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    className={`ui-toggle ${checked ? 'ui-toggle-on' : ''} ${stretch ? 'ui-toggle-stretch' : ''} ${className}`.trim()}
    onClick={() => onChange(!checked)}
    {...rest}
  >
    <span className="ui-toggle-track"><span className="ui-toggle-thumb" /></span>
    {label && <span className="ui-toggle-label">{label}</span>}
  </button>
);

export default Toggle;
